import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  nameCantBeBlank: {
    id: 'Alert.NameCantBeBlank',
    defaultMessage: "Name can't be blank."
  },
  stronglyRecommendArtifact: {
    id: 'Alert.StronglyRecommendArtifact',
    defaultMessage:
      'We strongly recommend an Artifact activity also be a Check-in to ensure Learners get good feedback.'
  },
  unusualMaterialsLimit: {
    id: 'Alert.UnusualMaterialsLimit',
    defaultMessage: 'Unusual Materials cannot exceed 1000 characters.'
  },
  questTitleTaken: {
    id: 'Alert.QuestTitleTaken',
    defaultMessage: 'Quest title has already been taken.'
  }
})



// WEBPACK FOOTER //
// ./src/utils/messages/alert.js